var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_836_3417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9583 5.79415C15.9071 5.63559 15.8104 5.4956 15.6802 5.39163C15.5501 5.28766 15.3922 5.2243 15.2262 5.20944L10.6082 4.79009L8.78209 0.515919C8.6474 0.202693 8.34077 0 8.00007 0C7.65937 0 7.35271 0.202724 7.21808 0.516701L5.39197 4.79012L0.7732 5.20944C0.607451 5.22463 0.449802 5.28812 0.3198 5.39206C0.189799 5.496 0.0931609 5.6358 0.0418688 5.79415C-0.0634776 6.11816 0.0338061 6.47351 0.290531 6.69751L3.78125 9.75884L2.75191 14.293C2.67659 14.6264 2.80597 14.971 3.0826 15.171C3.23126 15.2784 3.40524 15.3331 3.58065 15.3331C3.7319 15.3331 3.8819 15.2923 4.01659 15.2118L8.00007 12.831L11.9821 15.2118C12.2735 15.3871 12.6408 15.371 12.9168 15.171C13.0519 15.0732 13.1553 14.9378 13.2141 14.7817C13.2729 14.6256 13.2845 14.4557 13.2475 14.293L12.2182 9.75884L15.7089 6.69814C15.8345 6.58847 15.925 6.44432 15.9694 6.2836C16.0137 6.12289 16.0099 5.95269 15.9583 5.79415Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_836_3417"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.8e5f55dabaaae86037996bbd4d0ed2be.svg";
export { ForwardRef as ReactComponent };